import React from 'react';
import { useDynamicFormState } from './DynamicForm.state';
import DynamicFormView from './DynamicForm.view';

export type IDynamicFormType =
    | 'text'
    | 'text-field-with-max-length'
    | 'dropdown'
    | 'image'
    | 'visitor-entrance-video-player'
    | 'color'
    | 'multiline-text'
    | 'icon'
    | 'toggle'
    | 'checkbox'
    | 'section-heading'
    | 'personaSelector'
    | 'datepicker'
    | 'choicepicker'
    | 'room-list';

export interface IDynamicFormElementProps {
    key: string;
    type: IDynamicFormType;
    label?: string;
    value?: any;
    description?: string;
    callout?: string;
    width?: string;
    height?: string;
    isVisible?: boolean;
    disabled?: boolean;
    ariaLabel?: string;
}

const DynamicForm: React.FC<{ style?: any; formFields: IDynamicFormElementProps[]; onChange: (key: string, value: any) => void }> = (props) => {
    const state = useDynamicFormState(props.onChange);

    return (
        <DynamicFormView
            {...{
                ...state,
                ...{
                    formFields: props.formFields,
                    style: props.style
                }
            }}
        />
    );
};

export default DynamicForm;
